<template>
  <div>
    <arrive-notice
      v-if="soldOut"
      :use-icon="useArrivedNoticeIcon"
      :has-subscribed="hasSubscribedArrivedNotice"
      :goods-status="statusRemindInfo.goods_status"
      @subscribe="subscribe"
    />
    <simple
      v-else-if="useSimple"
      :show-count="showSimpleCount"
      :can-buy="canBuy"
      :count="count"
      @add="add"
    />
    <can-not-buy
      v-else-if="statusRemindInfo.goods_status !== 1"
      :goods-status="statusRemindInfo.goods_status"
      :status-show-name="statusRemindInfo.status_show_name"
      :no-buy-time-show="statusRemindInfo.no_buy_time_show"
      :open_remind="statusRemindInfo.open_remind"
    />
    <activity
      v-else-if="useActivity"
      :count="count"
      :activity-info="activityInfo"
      :btn-style="btnStyle"
      :show-count="showSimpleCount"
      :has-set-remind="hasSetRemind"
      @add="add"
      @seckillRemind="seckillRemind"
    />
    <complex
      v-else
      :can-buy="canBuy"
      :count="count"
      :status-remind-info="statusRemindInfo"
      @keyboard="input"
      @add="add"
      @sub="sub"
    />
    <remind-alert v-if="showRemindAlert" />
  </div>
</template>

<script>
import Simple from './atoms/simple'
import Complex from './atoms/complex'
import Activity from './atoms/activity'
import ArriveNotice from './atoms/arrive_notice'
import CanNotBuy from './atoms/can_not_buy'
import RemindAlert from './atoms/remind_alert'
import { cart } from '@/utils/cart/index'
import { API } from '@/api'
import { DialogAlert } from '@/utils/dialog.js'
import { $numberKeyboard } from '@/common/widgets/number_keyboard'
import { miniProgramEnv } from '../../../defines/environment'
import { mpsCombination } from '../../../utils/native_interactions/mps_combination'

export default {
  name: 'Operator',
  components: {
    Simple,
    Complex,
    ArriveNotice,
    CanNotBuy,
    Activity,
    RemindAlert
  },
  props: {
    ssu: {
      type: Object,
      default: () => ({})
    },
    useSimple: {
      type: Boolean,
      default: false
    },
    useActivity: {
      type: Boolean,
      default: false
    },
    showSimpleCount: {
      type: Boolean,
      default: false
    },
    useArrivedNoticeIcon: {
      type: Boolean,
      default: false
    },
    showPromoteTip: {
      type: Boolean,
      default: false
    },
    btnStyle: {
      type: Object,
      default: () => {}
    },
    activityInfo: {
      type: Object,
      default: () => {}
    },
    isHint: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      cartSsu: {},
      count: 0,
      addStatus: false,
      hasSetRemind: false, // 是否设置过即将开抢提醒(针对秒杀)
      showRemindAlert: false // 显示下午达提醒弹窗
    }
  },
  computed: {
    uniqueId() {
      return this.ssu.unique_id || this.ssu.ssu_id
    },
    hasPromote() {
      // eslint-disable-next-line camelcase
      const promoteType = this.ssu.promotion_remind_info?.promote_type ?? []
      return (
        promoteType.includes(2) || // 普通商品2和购物车3是一个东西
        promoteType.includes(3) ||
        promoteType.includes(4) ||
        promoteType.includes(21) || // 会员价（标签展示），新增类型
        promoteType.includes(12) // 会员 目前不再使用
      )
    },
    statusRemindInfo() {
      // eslint-disable-next-line camelcase
      const fromGood = this.ssu?.status_remind_info
      // eslint-disable-next-line camelcase
      const fromCart = this.cartSsu?.statusRemindInfo

      const fromGoodExistAndParticipate =
        fromGood &&
        Number(fromGood.goods_status) === 8 &&
        Object.keys(fromGood).length > 0

      const fromCartExist = fromCart && Object.keys(fromCart).length > 0

      // 针对秒杀特殊处理
      // 已参与状态，通过购物车加购时，会拿到购物车的可加购状态，从而导致展示错误
      if (this.useActivity && fromGoodExistAndParticipate) {
        return fromGood || {}
      } else if (fromCartExist) {
        return fromCart || {}
      } else {
        return fromGood || {}
      }
    },
    promotionRemindInfo() {
      // eslint-disable-next-line camelcase
      const fromGood = this.ssu?.promotion_remind_info
      // eslint-disable-next-line camelcase
      const fromCart = this.cartSsu?.promotionRemindInfo
      if (fromCart === undefined) {
        return fromGood
      } else {
        return fromCart
      }
    },
    soldOut() {
      // 只有当商品库存为0，也就是stock_num为0，或者goods_status=3(已售罄)时才展示到货提醒
      const { goods_status: status } = this.statusRemindInfo || {}
      const stockNum =
        // eslint-disable-next-line camelcase
        this.ssu?.stock_num || this.cartSsu?.stock_num || undefined
      return status === 3 || (stockNum && stockNum <= 0)
    },
    canBuy() {
      const { goods_status: status } = this.statusRemindInfo
      return !this.soldOut && (status === 1 || status === 102)
    },
    hasSubscribedArrivedNotice() {
      return this.cartSsu.hasSubscribed
    },
    promoteTip() {
      const promotionGoodsNum =
        // eslint-disable-next-line camelcase
        this.promotionRemindInfo?.promotion_goods_num || 0
      const count = this.count - promotionGoodsNum
      if (this.hasPromote && promotionGoodsNum > 0 && count > 0) {
        // eslint-disable-next-line camelcase
        return this.promotionRemindInfo?.contain_normal_goods_remind
          ? this.promotionRemindInfo.contain_normal_goods_remind.replace(
              '##PARAM##',
              count
            )
          : `包含${count}件原价商品`
      } else {
        return ''
      }
    }
  },
  async created() {
    this.cartSsu = cart.getByUniqueId(this.uniqueId, {
      // eslint-disable-next-line camelcase
      hasSubscribed: this.ssu?.status_remind_info?.arrived_notice_status
    })
    this.count = this.cartSsu.count
    this._cart_ssu_subscribe_id = this.cartSsu.subscribe(good => {
      if (!this.addStatus) {
        this.cartSsu = good
        this.count = good.count
      }
    })

    // 判断当前商品是否设置过提醒(秒杀,即将开始)
    this.activityInfo?.status === 0 && this.judgeHasRemind({ noClick: true })
  },
  beforeDestroy() {
    this._cart_ssu_subscribe_id &&
      this.cartSsu.unsubscribe(this._cart_ssu_subscribe_id)
  },
  methods: {
    async add() {
      if (this.canBuy) {
        const original = this.count
        // 针对秒杀做促销商品数量限制弹窗处理
        const canBuy = this.seckillHandler(this.count)
        if (!canBuy) return

        try {
          if (this.count <= 998) {
            this.count += 1
            this.addStatus = true
            const res = await cart.debounceAdd(this.uniqueId)
            const newval = res.light_cart_ssus[0]
            if (newval?.status_remind_info?.goods_status === 9) {
              this.$toast(newval?.status_remind_info?.no_buy_time_remind)
            }
            this.addStatus = false
            this.$emit('add', this.ssu)
            if (miniProgramEnv.isMiniProgram) {
              mpsCombination.postMessage({
                data: {
                  type: 'addCart'
                }
              })
            }
          } else {
            this.$toast('购买不能大于999件')
          }
        } catch (error) {
          this.addStatus = false
          this.count = original
        }

        this.showRemindAlert = Number(this.isHint) === 1
      }
    },
    async sub() {
      this.count >= 1 && (this.count -= 1)
      await cart.debounceSubtract(this.uniqueId)
      this.$emit('subtract', this.ssu)
      mpsCombination.postMessage({
        data: {
          type: 'addCart'
        }
      })
    },
    async input() {
      try {
        const num = await $numberKeyboard(this.count)
        this.count = num
        await cart.put({
          ssu_list: [
            {
              unique_id: this.uniqueId,
              num
            }
          ]
        })
        this.$emit('add', this.ssu)
      } catch (e) {
        if (e.res && e.res.error) {
          const { msg } = e.res.error
          this.$toast(msg)
        }
      }
    },
    async subscribe() {
      try {
        const data = await cart.subscribe(this.uniqueId)
        const msg = typeof data === 'string' ? data : data.msg
        this.$toast(msg)
        this.$emit('subscribe', this.ssu)
      } catch (e) {
        const { error } = e
        if (error) {
          const { msg } = error
          this.$toast(msg)
        }
      }
    },
    // 秒杀活动处理
    seckillHandler(currentCount) {
      if (currentCount >= this.statusRemindInfo.available_amount) {
        this.$toast({
          message: this.statusRemindInfo.out_available_amount_remind
        })
        return false
      }
      // 针对促销限制优惠商品数量进行弹窗提示
      // 例如：第二件商品恢复原价
      if (
        this.hasPromote &&
        this.promotionRemindInfo.promotion_goods_num > 0 &&
        currentCount <= this.promotionRemindInfo.promotion_goods_num &&
        currentCount + 1 > this.promotionRemindInfo.promotion_goods_num
      ) {
        this.$toast({
          message: this.promotionRemindInfo.over_promotion_remind
        })
      }
      return true
    },
    // 秒杀即将开抢设置提醒
    async seckillRemind() {
      if (this.hasSetRemind) return
      const message = '设置成功，开抢前五分钟提醒'

      // eslint-disable-next-line camelcase
      const { ssu_id, activity_id, sbu_name } = this.ssu
      try {
        await API.cms.postSubscribe({
          ssu_id,
          activity_id,
          sbu_name
        })
        this.judgeHasRemind()
        // 埋点
        this.$track('2043.0', {
          ssu_id,
          // eslint-disable-next-line camelcase
          activity_id: activity_id ? activity_id + '' : ''
        })
        // 小程序订阅处理
        if (miniProgramEnv.isMiniProgram) {
          mpsCombination.postMessage({
            data: {
              type: 'addCart'
            }
          })
        }
        // 弹窗提示
        this.$toast({
          message,
          icon: 'success'
        })
      } catch (error) {
        console.log(error)
        DialogAlert('请检查您的网络是否通畅', {
          confirmButtonText: '知道了'
        })
      }
    },
    // 判断秒杀商品是否已经设置过提醒
    judgeHasRemind({ noClick = false } = {}) {
      const startTime = this.activityInfo.startTime
      const storeKey = startTime.getTime() + '-' + this.ssu.ssu_id
      const localCache =
        JSON.parse(localStorage.getItem('seckill_good_remind')) || []

      // 针对初始化判断是否已经设置过提醒
      if (noClick) {
        localCache.includes(storeKey) && (this.hasSetRemind = true)
        return
      }

      // 如果从未设置提醒
      if (!localCache.includes(storeKey)) {
        localCache.push(storeKey)
        localStorage.setItem('seckill_good_remind', JSON.stringify(localCache))
        this.hasSetRemind = true
      } else if (new Date().getTime() >= startTime.getTime()) {
        // 已经设置过，但是过了提醒时间
        const removeIndex = localCache.indexOf(storeKey)
        localCache.splice(removeIndex, 1)
        localStorage.setItem('seckill_good_remind', JSON.stringify(localCache))
      }
    }
  }
}
</script>
